import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center w-full mt-4 space-x-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "send", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Avatar, {
      class: "",
      user: _ctx.metaStore.user
    }, null, 8, ["user"]),
    _createVNode(_component_TextInput, {
      onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.onSend()), ["enter"])),
      class: "w-full",
      modelValue: _ctx.draft,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.draft) = $event)),
      placeholder: _ctx.$t('exercise_solution.add_comment')
    }, null, 8, ["modelValue", "placeholder"]),
    _createVNode(_component_Btn, {
      disabled: !_ctx.isValidMessage,
      loading: _ctx.posting,
      variant: 'secondary',
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSend()))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled", "loading"])
  ]))
}